'use strict';

import { Entity } from '../Entity';

export class AgencyLogo extends Entity {
  protected logoId;

  protected agencyId;

  protected logoName;

  protected logoWidth;

  protected logoMarginTop;

  protected logoMarginLeft;

  protected logoHeaderColor;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.logoId = data.logoId;

    this.agencyId = data.agencyId;

    this.logoName = data.logoName;

    this.logoWidth = data.logoWidth;

    this.logoMarginTop = data.logoMarginTop;

    this.logoMarginLeft = data.logoMarginLeft;

    this.logoHeaderColor = data.logoHeaderColor;
  }

  public getLogoId() {
    return this.logoId;
  }

  public setLogoId(logoId) {
    this.logoId = logoId;

    return this;
  }

  public getAgencyId() {
    return this.agencyId;
  }

  public setAgencyId(agencyId) {
    this.agencyId = agencyId;

    return this;
  }

  public getLogoName() {
    return this.logoName;
  }

  public setLogoName(logoName) {
    this.logoName = logoName;

    return this;
  }

  public getLogoWidth() {
    return this.logoWidth;
  }

  public setLogoWidth(logoWidth) {
    this.logoWidth = logoWidth;

    return this;
  }

  public getLogoMarginTop() {
    return this.logoMarginTop;
  }

  public setLogoMarginTop(logoMarginTop) {
    this.logoMarginTop = logoMarginTop;

    return this;
  }

  public getLogoMarginLeft() {
    return this.logoMarginLeft;
  }

  public setLogoMarginLeft(logoMarginLeft) {
    this.logoMarginLeft = logoMarginLeft;

    return this;
  }

  public getLogoHeaderColor(includeHex: boolean = false): string | null {
    if (includeHex && this.logoHeaderColor) {
      return '#' + this.logoHeaderColor;
    }

    return this.logoHeaderColor;
  }

  public setLogoHeaderColor(logoHeaderColor) {
    this.logoHeaderColor = logoHeaderColor;

    return this;
  }
}
